import { isDefined } from '@grandvisionhq/utils';
import { CartDiscountType } from './types.js';

const mappedType = (type)=>{
    switch(type){
        case 'PERCENT':
            return CartDiscountType.PERCENT;
        case 'AMOUNT':
            return CartDiscountType.AMOUNT;
        default:
            throw new Error(`Unknown cart discount type: ${type}`);
    }
};
const mapCartDiscountToClient = (serverCartDiscounts)=>{
    if (!serverCartDiscounts) {
        return [];
    }
    const mappedDiscounts = serverCartDiscounts.map(({ type , amount , minimumQuantity  })=>{
        if (!minimumQuantity || !amount) {
            return undefined;
        }
        const discount = {
            minimumQuantity,
            type: 'quantity-discount',
            discount: {
                type: mappedType(type),
                amount
            }
        };
        return discount;
    }).filter(isDefined);
    const sortedAscendingDiscounts = [
        ...mappedDiscounts
    ].sort((a, b)=>a.minimumQuantity - b.minimumQuantity
    );
    return sortedAscendingDiscounts;
};
/**
 * @deprecated This function is only used on the v1 CL template
 */ const mapLegacyCartDiscountToClientCartDiscount = (serverCartDiscounts)=>{
    if (!serverCartDiscounts) {
        return [];
    }
    return serverCartDiscounts.map(({ minimumQuantity , amount , type  })=>{
        return {
            minimumQuantity: minimumQuantity !== null && minimumQuantity !== void 0 ? minimumQuantity : 0,
            amount: amount !== null && amount !== void 0 ? amount : 0,
            type: mappedType(type)
        };
    });
};

export { mapCartDiscountToClient, mapLegacyCartDiscountToClientCartDiscount };
//# sourceMappingURL=map-to-client-cart-discount.js.map
